"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnounceShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const announce_1 = require("../../../model/announce");
const confirm_1 = require("../../../utils/confirm");
const helpers_1 = require("../../../utils/helpers");
const right_panel_1 = require("../../../widgets/right_panel");
const announce_table_1 = require("./announce_table");
const moment = require("moment");
exports.AnnounceShow = {
    announce: {},
    fetched: false,
    oncreate(vnode) {
        let id = vnode.attrs.id;
        this.fetch(id);
    },
    fetch(id) {
        exports.AnnounceShow.fetched = false;
        announce_1.AnnounceProvider.show(id).then((announce) => {
            exports.AnnounceShow.announce = announce;
            exports.AnnounceShow.fetched = true;
            mithril_1.default.redraw();
        });
    },
    view(_vnode) {
        var _a;
        let ann = exports.AnnounceShow.announce;
        return (0, mithril_1.default)(".content", (0, mithril_1.default)("h3", `Annonce #${ann.id}`), (0, mithril_1.default)("hr"), (0, mithril_1.default)("button.button.is-danger", { onclick: () => {
                confirm_1.Confirm.confirm("Cette opération est irréversible. Etes-vous sûr?").then(() => __awaiter(this, void 0, void 0, function* () {
                    yield announce_1.AnnounceProvider.delete(ann.id);
                    right_panel_1.RightPanel.close();
                    announce_table_1.AnnounceTable.fetch();
                }));
            } }, "Supprimer"), (0, mithril_1.default)("hr"), (0, helpers_1.renderProperties)({
            "Titre": ann.title,
            "Contenu": ann.content,
            "Établissement": (0, helpers_1.tag)((_a = ann.venue) === null || _a === void 0 ? void 0 : _a.name),
            "Date:": [
                (0, helpers_1.tag)(app_1.App.longDateFormat(moment(ann.starts_at))),
                (0, mithril_1.default)("div", " de ", (0, helpers_1.tag)(moment(ann.starts_at).format("HH:mm")), " à ", (0, helpers_1.tag)(moment(ann.ends_at).format("HH:mm")))
            ]
        }));
    }
};
